
import store from "@/store/store"

import Vue from "vue"
import { Component } from "vue-property-decorator"

import router from "@/router/router"

Component.registerHooks(["beforeRouteEnter"])

@Component({})
export default class MasterdataClientMainView extends Vue {
    beforeRouteEnter(to: any, from: any, next: any) {
        const regex = new RegExp("^/sections/masterdata/client?$")
        const result = (to.path as string).match(regex)

        if (result) {
            router.push({ path: "/sections/masterdata/client/list" })
        } else {
            next()
        }
    }

    get item() {
        return store.state.client.single.value
    }
}
